import axios from "axios";
import baseUrls from "./baseUrls";
import { removerSessaoAtiva } from "../util/libLocalStorage";

export const createAPI = (serviceName) => {
	const baseURL = baseUrls[serviceName];

	if (!baseURL) {
		throw new Error(`Base URL não encontrada para o serviço: ${serviceName}`);
	}

	const apiServer = axios.create({ baseURL, withCredentials: true });

	// Intercepta o response depois dele acontecer
	apiServer.interceptors.response.use(
		(response) => response,
		(error) => {
			if (!error.response) {
				error = {
					message:
						"Não foi possível encontrar o servidor. Por favor, verifique sua conexão com a internet e tente novamente.",
					status: 0,
				};
			} else if (error.response.status === 401) {
				removerSessaoAtiva();
				document.location = "/login"; // Redireciona para o login
				error = {
					message: error.response.data,
					status: error.response.status,
				};
			} else if (isHTML(error.response.data)) {
				error = {
					message: error.message + " " + error.code,
					status: error.response.status,
				};
			} else {
				if (error.response.data.errorJson) {
					const { errorJson: message, field } = error.response.data;
					const statusCode = error.response.status;
					error = { message, field, statusCode };
				} else {
					error = {
						message: error.response.data,
						status: error.response.status,
					};
				}
			}
			throw error;
		},
	);
	// Função para verificar se a resposta é HTML
	function isHTML(str) {
		const htmlRegex = /<([A-Za-z][A-Za-z0-9]*)\b[^>]*>(.*?)<\/\1>/;
		return htmlRegex.test(str);
	}

	return apiServer;
};
